import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  panel: {
    backgroundColor: theme.palette.white,
    borderRadius: '6px 6px 0px 0px',
  },
}));

export default useStyles;
